<template>
  <v-footer
    v-if="show"
    :app="app"
    :padless="padless"
    :fixed="fixed"
    :absolute="absolute"
    :inset="inset"
    v-bind="bindStyle"
  >
    <v-row justify="start" align="center">
      <v-col class="text-left px-8" cols="6" lg="6" md="6">
        <small>
        &copy;{{ new Date().getFullYear() }}
        <a href="http://sling3.com/" target="_blank"
          >Ling Enterprises, INC</a
        >
        </small>
      </v-col>
      <v-col class="text-right px-8" cols="6" lg="6" md="6">
        <small>
        Support: <v-icon small color="primary">phone</v-icon>
        <a href="tel:8585983385" target="_blank">(858) 598-3885</a>
        </small>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      account: (state) => state.account.data.permissions,
    }),
    ...mapGetters("navigations", [
      "isVisibleFooter",
      "isAppFooter",
      "isFixedFooter",
      "isAbsoluteFooter",
      "isInsetFooter",
      "isPadlessFooter",
    ]),
    ...mapGetters("scheme", ["footer"]),
    show() {
      return this.isVisibleFooter;
    },
    app() {
      return this.isAppFooter;
    },
    fixed() {
      return this.isFixedFooter;
    },
    absolute() {
      return this.isAbsoluteFooter;
    },
    inset() {
      return this.isInsetFooter;
    },
    padless() {
      return this.isPadlessFooter;
    },
    bindStyle() {
      const { color, dark, classes } = this.footer;
      return {
        class: {
          "vuse-footer": true,
          [classes]: true,
        },
        dark,
        color,
        style: {
          width: "auto",
          ...(this.isFixedFooter ? { "z-index": 9 } : {}),
        },
      };
    },
  },
};
</script>